export { message } from 'antd'
export type { MessageArgsProps } from 'antd'
export * from './showMessage'
